import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Card = styled.div<SizeProps>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;
